"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _modalModule = _interopRequireDefault(require("./modal.module.css"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalHeader = function ModalHeader(props) {
  var id = props.id,
      title = props.title,
      onClose = props.onClose;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: _modalModule.default["modal-header"]
  }, _react.default.createElement("button", {
    id: id ? "".concat(id, "_close") : null,
    type: "button",
    className: _modalModule.default["modal-close"],
    "data-dismiss": "modal",
    "aria-label": "Close",
    onClick: onClose,
    lang: "aragUilib"
  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_icon") : null,
    "aria-hidden": "true"
  }, "\xD7")), _react.default.createElement("h4", {
    className: _modalModule.default["modal-title"],
    id: id ? "".concat(id, "_title") : null
  }, title));
};

ModalHeader.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text*/
  title: _propTypes.default.string,

  /** Callback invoked on modal close button click */
  onClose: _propTypes.default.func
};
var _default = ModalHeader;
exports.default = _default;